import { useSearchParams } from '@ksyos/router';
import { SomnologyOrganizationType } from '../../../common/enums/SomnologyOrganizationType';
import { ChapterTitle } from '../elements/atoms/chapterTitle/ChapterTitle';
import { ExternalLink } from '../elements/atoms/externalLink/ExternalLink';
import { HeroText } from '../elements/atoms/heroText/HeroText';
import { PageTitle } from '../elements/atoms/pageTitle/PageTitle';
import { Paragraph } from '../elements/atoms/paragraph/Paragraph';
import { Article } from '../elements/molecules/article/article';
import { Container } from '../elements/molecules/container/Container';
import { FaqItem } from '../elements/molecules/faqItem/FaqItem';
import { List } from '../elements/molecules/list/List';
import { ListItem } from '../elements/molecules/listItem/ListItem';
import { Main } from '../elements/molecules/main/Main';
import { PageSection } from '../elements/molecules/pageSection/PageSection';
import { Footer } from '../elements/organisms/footer/Footer';
import { Header } from '../elements/organisms/header/Header';
import { PageWrapper } from '../elements/organisms/pageWrapper/PageWrapper';

function nsiFaq() {
    const faqItem1 = (
        <Paragraph>
            De voorkeur heeft de wijsvinger aan de niet dominante hand. <strong>Let op:</strong> Trek de beschermsticker
            pas los als de vingersonde goed zit. Als de vingersonde niet om de wijsvinger past, doe hem dan om je pink.
            De vingersonde kan niet gebruikt worden om je duim.
        </Paragraph>
    );

    const faqItem2 = (
        <>
            <Paragraph>
                Binnen twee weken na het slaaponderzoek neemt het Nederlands Slaap Instituut (NSI) contact met je op om
                het videoconsult in te plannen.
            </Paragraph>
            <Paragraph>
                De medisch specialist (somnoloog) van het NSI verricht gedurende dit videoconsult een nadere anamnese en
                eventueel vervolgonderzoek. De bevindingen van het slaaponderzoek worden besproken waarna er (indien
                mogelijk) een diagnose zal worden gesteld.
            </Paragraph>
            <Paragraph>
                Indien een videoconsult niet mogelijk is wordt er een afspraak op een spreekuurlocatie gepland.
            </Paragraph>
        </>
    );

    const faqItem3 = (
        <>
            <Paragraph>
                Wanneer er binnen twee weken na het onderzoek geen contact met je is opgenomen, neem dan contact op met
                het NSI:
            </Paragraph>
            <List>
                <ListItem>
                    Telefoon: <ExternalLink href="tel:085 0710900">085 0710900</ExternalLink>
                </ListItem>
                <ListItem>
                    E-mail:{' '}
                    <ExternalLink href="mailto:secretariaat@nederlandsslaapinstituut.nl">
                        secretariaat@nederlandsslaapinstituut.nl
                    </ExternalLink>
                </ListItem>
            </List>
        </>
    );
    const faqItem4 = (
        <>
            <Paragraph>
                Afhankelijk van de ernst en oorzaak van slaapapneu wordt er samen met jou bepaald welk behandelplan het
                beste bij jou past. Er zijn verschillende behandelopties mogelijk:
            </Paragraph>
            <List>
                <ListItem>
                    <strong>Leefstijl advies:</strong> In sommige gevallen wordt slaapapneu primair veroorzaakt door
                    ongezonde leefgewoonten. Advies kan bijvoorbeeld gericht zijn op het verkrijgen van een actieve
                    leefstijl en het realiseren en behouden van een gezond gewicht.
                </ListItem>
                <ListItem>
                    <strong>MRA (Mandibulair Repositie Apparaat):</strong> Een MRA is een snurkbeugel. Deze is met name
                    bedoeld voor mensen die snurken of licht tot matige slaapapneu hebben. De MRA zorgt ervoor dat de
                    onderkaak iets naar voren wordt getrokken waardoor de luchtpijp verder wordt geopend. Voor een MRA
                    zal je verwezen worden naar een gecertificeerde (NVTS) tandarts in de buurt.
                </ListItem>
                <ListItem>
                    <strong>Slaap Positie Therapie (SPT):</strong> De slaap positie trainer is geschikt voor mensen met
                    licht tot matige positieafhankelijke slaapapneu. Dit kleine apparaatje zorgt ervoor dat je niet meer
                    op de rug slaapt waardoor het aantal ademstops fors wordt verminderd.
                </ListItem>
                <ListItem>
                    <Paragraph>
                        <strong>CPAP (Continuous Positive Airway Pressure):</strong> De CPAP is een geschikte
                        behandeling bij ernstige slaapapneu. Via een masker blaast het apparaat lucht naar binnen indien
                        je een ademstop dreigt te krijgen.
                    </Paragraph>
                    <Paragraph>
                        Wanneer een CPAP de meest geschikte behandelmethode voor jou is zal er een CPAP-consulent bij
                        jou thuis langskomen voor het aanmeten van de apparatuur.
                    </Paragraph>
                    <Paragraph>
                        Na de proefperiode wordt het apparaat uitgelezen en zal de medisch specialist (somnoloog)
                        bepalen wat de optimale druk instelling is.
                    </Paragraph>
                </ListItem>
                <ListItem>
                    <strong>Chirurgische therapie:</strong> Voor een klein percentage van mensen met slaapapneu is een
                    chirurgische ingreep noodzakelijk. Dit heeft in de meeste gevallen niet de voorkeur. Als een
                    chirurgische ingreep noodzakelijk is, word je doorverwezen naar een ziekenhuis dat hierin
                    gespecialiseerd is.
                </ListItem>
            </List>
        </>
    );

    const faqItem5 = (
        <>
            <Paragraph>
                Het slaaponderzoek wordt vergoed binnen het basispakket van de zorg. Je hoeft hier dus geen aanvullende
                verzekering voor te hebben. De kosten tellen mee voor het openstaande eigen risico. Afhankelijk van je
                zorgverzekeraar vergoedt de zorgverzekeraar 65% tot 100% van het gefactureerde bedrag. Het NSI zal het
                verschil tussen het factuurbedrag en dat wat de zorgverzekeraar aan jou vergoedt, voor haar eigen
                rekening nemen. Je betaalt dus nooit meer dan het eigen risico.
            </Paragraph>
            <Paragraph>Neem bij vragen contact op met het NSI of kijk op de website:</Paragraph>
            <List>
                <ListItem>
                    Website:{' '}
                    <ExternalLink href="https://www.nederlandsslaapinstituut.nl/kosten-vergoedingen/">
                        https://www.nederlandsslaapinstituut.nl/kosten-vergoedingen/
                    </ExternalLink>
                </ListItem>
                <ListItem>
                    Telefoon: <ExternalLink href="tel:085 0710900">085 0710900</ExternalLink>
                </ListItem>
                <ListItem>
                    E-mail:{' '}
                    <ExternalLink href="mailto:secretariaat@nederlandsslaapinstituut.nl">
                        secretariaat@nederlandsslaapinstituut.nl
                    </ExternalLink>
                </ListItem>
            </List>
        </>
    );

    const faqItem6 = (
        <>
            <Paragraph>
                Je dient de factuur in bij je eigen zorgverzekeraar. Je betaalt de factuur pas aan het NSI wanneer je
                het bedrag van de zorgverzekeraar hebt ontvangen.
            </Paragraph>
            <Paragraph>Neem bij vragen contact op met het NSI:</Paragraph>
            <List>
                <ListItem>
                    Telefoon: <ExternalLink href="tel:085 0710900">085 0710900</ExternalLink>
                </ListItem>
                <ListItem>
                    E-mail:{' '}
                    <ExternalLink href="mailto:secretariaat@nederlandsslaapinstituut.nl">
                        secretariaat@nederlandsslaapinstituut.nl
                    </ExternalLink>
                </ListItem>
            </List>
        </>
    );

    return (
        <PageWrapper>
            <Header
                backButtonText="Terug"
                hasBackbutton
                hasLogoutButton
            />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Veelgestelde vragen</PageTitle>
                            <HeroText>
                                Kom je er niet uit? Hier vind je hier de meest voorkomende vragen, staat jouw vraag er
                                niet tussen? Neem dan contact met ons op.
                            </HeroText>
                        </Article>
                    </PageSection>
                    <PageSection>
                        <Article>
                            <ChapterTitle>Over Osas</ChapterTitle>
                        </Article>
                    </PageSection>
                    <FaqItem
                        answer="Je slaapt één nacht met de slaaprecorder. Nadat je met de slaaprecorder hebt geslapen lever je de recorder weer in bij de huisartsenpraktijk."
                        question="Hoeveel nachten moet ik met de slaaprecorder slapen?"
                    />
                    <FaqItem
                        answer={faqItem1}
                        question="Om welke vinger kan ik de vingersonde het beste doen?"
                    />
                    <FaqItem
                        answer="Geef dit aan bij de assistente op het moment dat je de slaaprecorder inlevert. Nadat de assistente het slaaponderzoek heeft verstuurd naar het NSI zal de medisch specialist kijken of er voldoende informatie in de opname zit om een beoordeling te kunnen geven. Als dit niet het geval is, dan neemt de huisartsenpraktijk contact met je op om het slaaponderzoek opnieuw te doen."
                        question="De vingersonde en/of borstplakker is ‘s nachts afgegaan, wat nu?"
                    />
                    <FaqItem
                        answer="Indien de slaaprecorder al aanstaat en je nog niet gaat slapen, kan je deze helaas niet meer uitzetten. Ga langs bij de huisarts om de apparatuur opnieuw in te laten stellen."
                        question="Wat moet ik doen als de slaaprecorder al aanstaat, voordat ik echt ga slapen?"
                    />
                    <FaqItem
                        answer={faqItem2}
                        question="Ik heb een slaaponderzoek gedaan. Wat is de volgende stap?"
                    />
                    <FaqItem
                        answer={faqItem3}
                        question="Ik heb een slaaponderzoek gedaan maar er is nog geen contact met me opgenomen, wat kan ik doen?"
                    />
                    <FaqItem
                        answer={faqItem4}
                        question="Uit het onderzoek is gebleken dat ik slaapapneu heb, wat nu?"
                    />
                    <FaqItem
                        answer={faqItem5}
                        question="Wat kost een slaaponderzoek?"
                    />
                    <FaqItem
                        answer={faqItem6}
                        question="Ik heb een factuur ontvangen van het NSI, wat moet ik hier mee doen?"
                    />
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}

function ksyosMedicalCenterFaq() {
    const contactEmail = <ExternalLink href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</ExternalLink>;
    const infoEmail = <ExternalLink href="mailto:info@ksyos.nl">info@ksyos.nl</ExternalLink>;
    const infoPhone = <ExternalLink href="tel:020-6000060">020-600 00 60</ExternalLink>;

    const faqItem1 = (
        <>
            <Paragraph>
                Volg de instructies die zijn bijgevoegd bij de slaaprecorder. Indien je hierover vragen hebt, bel dan
                met {infoPhone} of mail naar {contactEmail}.
            </Paragraph>
            <Paragraph>
                Zorg dat je de vingerprobe (stap 9) pas uitvoert wanneer je daadwerkelijk gaat slapen. Dit kan namelijk
                maar eenmalig!
            </Paragraph>
        </>
    );

    const faqItem2 = (
        <>
            <Paragraph>
                Afhankelijk van de ernst en oorzaak van slaapapneu wordt er samen met jou bepaald welk behandelplan het
                beste bij jou past.
            </Paragraph>

            <Paragraph>Er zijn verschillende behandelopties mogelijk:</Paragraph>

            <Paragraph>
                <i>Lifestyle advies</i>
                <br />
                In sommige gevallen wordt slaapapneu primair veroorzaakt door ongezonde leefgewoonten. Advies kan
                bijvoorbeeld gericht zijn op het verkrijgen van een actieve leefstijl en het realiseren en behouden van
                een gezond gewicht.
            </Paragraph>

            <Paragraph>
                <i>MRA (Mandibulair Repositie Apparaat)</i>
                <br />
                Een MRA is een snurkbeugel. Deze is met name bedoeld voor mensen die snurken of licht tot matige
                slaapapneu hebben. De MRA zorgt ervoor dat de onderkaak iets naar voren wordt getrokken, waardoor de
                luchtpijp verder wordt geopend. Voor een MRA word je verwezen naar een gecertificeerde (NVTS) tandarts
                in de buurt.
            </Paragraph>

            <Paragraph>
                <i>Slaap Positie Therapie (SPT)</i>
                <br />
                De slaap positie trainer is geschikt voor mensen met licht tot matige positieafhankelijke slaapapneu.
                Deze specifieke vorm van slaapapneu houdt in dat je met name in rugligging veel apneus hebt. De positie
                trainer is een klein apparaatje dat ervoor zorgt dat je niet meer op de rug slaapt, waardoor het aantal
                ademstops fors vermindert.
            </Paragraph>

            <Paragraph>
                <i>CPAP (Continuous Positive Airway Pressure)</i>
                <br />
                De CPAP is vooral een geschikte behandeling bij matige of ernstige slaapapneu. Via een masker blaast het
                apparaat lucht naar binnen indien je een ademstop dreigt te krijgen. Wanneer een CPAP de meest geschikte
                behandelmethode voor jou is, zal er een CPAP-consulent bij jou thuis langskomen voor het aanmeten van de
                apparatuur. Na de proefperiode wordt het apparaat uitgelezen en bepaalt de medisch specialist wat de
                optimale druk instelling is.
            </Paragraph>

            <Paragraph>
                <i>Chirurgische therapie</i>
                <br />
                Voor een klein percentage mensen met slaapapneu is een chirurgische ingreep een goede oplossing. Dit
                heeft meestal niet de voorkeur. Als een chirurgische ingreep noodzakelijk is, word je doorverwezen naar
                een ziekenhuis dat hierin gespecialiseerd is.
            </Paragraph>

            <Paragraph>
                Kijk voor meer informatie ook in MijnKsyos, hier vind je bijvoorbeeld ook de presentatie van de arts
                terug.
            </Paragraph>
        </>
    );

    const faqItem3 = (
        <>
            <Paragraph>
                Het slaaponderzoek wordt vergoed vanuit de basisverzekering. Je hebt dus geen aanvullende verzekering
                nodig. Houd er wel rekening mee dat de zorg eigen risico belast is, net als zorg in het ziekenhuis.
            </Paragraph>
            <Paragraph>Wat je uiteindelijk moet betalen voor het onderzoek hangt dus af van twee zaken </Paragraph>
            <Paragraph>
                1) Hoeveel eigen risico je nog open hebt staan
                <br />
                2) Bij welke zorgverzekeraar je zit
            </Paragraph>
            <Paragraph>
                Afhankelijk van je zorgverzekeraar wordt 65% tot 100% van het gefactureerde bedrag vergoed. Ksyos neemt
                het verschil tussen het factuurbedrag en wat de zorgverzekeraar vergoedt voor haar rekening. Je betaalt
                dus nooit meer dan je openstaand eigen risico voor het slaaponderzoek.
            </Paragraph>
        </>
    );

    const faqItem4 = (
        <>
            <Paragraph>
                Je hebt een mail gekregen met instructies hiervoor. In deze mail kan je een begeleidende brief en
                stappenplan vinden hoe jij je zorg kan declareren bij je zorgverzekeraar. Is het nog onduidelijk? Neem
                dan contact op via {infoPhone} (kies 2) of stuur een mail naar {infoEmail}.
            </Paragraph>
            <Paragraph>
                Als je verzekerd bent bij VGZ, Zorg en Zekerheid, ENO, ONVZ, Caresq, ASR, of DSW; dan sturen we de
                factuur rechtstreeks naar de zorgverzekeraar.
            </Paragraph>
        </>
    );

    return (
        <PageWrapper>
            <Header
                backButtonText="Terug"
                hasBackbutton
                hasLogoutButton
            />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Veelgestelde vragen</PageTitle>
                            <HeroText>
                                Kom je er niet uit? Hier vind je de meest voorkomende vragen. Staat jouw vraag er niet
                                tussen? Neem dan contact met ons op via {infoPhone} of {contactEmail}.
                            </HeroText>
                            <ChapterTitle>Het slaaponderzoek voorbereiden</ChapterTitle>
                        </Article>
                        <FaqItem
                            answer={
                                <>
                                    Zoek in de mail op “Ksyos”. Controleer of de e-mail niet in de spambox terecht is
                                    gekomen. Heb je geen e-mail ontvangen? Neem contact met ons op via {infoPhone} of{' '}
                                    {contactEmail}.
                                </>
                            }
                            question="Ik heb geen e-mail ontvangen, wat nu?"
                        />
                        <FaqItem
                            answer={faqItem1}
                            question="Ik heb een WatchPAT gekregen, wat moet ik doen?"
                        />
                        <FaqItem
                            answer={
                                <>
                                    De pincode voor de WatchPAT ONE is de laatste 4 cijfers van jouw BSN-nummer. Je hebt
                                    4 pogingen. Als het niet lukt, neem dan contact op via {infoPhone} of {contactEmail}
                                    .
                                </>
                            }
                            question="Waar vind ik mijn pincode?"
                        />
                        <FaqItem
                            answer="Je slaapt 1 nacht met de slaaprecorder. De slaaprecorder meet de gegevens van 1 nacht. "
                            question="Hoeveel nachten moet ik met de slaaprecorder slapen?"
                        />
                        <FaqItem
                            answer="Nee, je kunt tijdens het slaaponderzoek gewoon naast je partner slapen. "
                            question="Is het de bedoeling dat ik tijdens het slaaponderzoek alleen (zonder partner) slaap?"
                        />
                        <FaqItem
                            answer="Ja, je kan het bed verlaten om bijvoorbeeld naar de wc te gaan. "
                            question="Kan ik ‘s nachts mijn bed verlaten met de slaaprecorder?"
                        />
                        <FaqItem
                            answer={
                                <>
                                    Indien er binnen twee weken na het onderzoek geen contact met je is opgenomen, neem
                                    dan contact met ons op via {infoPhone} of {contactEmail}.
                                </>
                            }
                            question="Ik heb een slaaponderzoek gedaan maar er is nog geen contact met me opgenomen. Wat kan ik doen?"
                        />
                        <FaqItem
                            answer="Zorg ervoor dat de huid schoon is, zoveel mogelijk haarvrij en vrij van vettige crème. Als de sensor toch niet blijft zitten, kun je een extra stukje tape of een pleister gebruiken."
                            question="De sensor blijft niet plakken, wat moet ik doen?"
                        />
                        <FaqItem
                            answer={
                                <>
                                    Binnen twee werkdagen bellen wij jou met telefoonnummer {infoPhone} om een
                                    videoconsult in te plannen. Tijdens dit consult bespreken we uitslag van het
                                    slaaponderzoek en vragen we naar je klachten. Indien mogelijk wordt er een diagnose
                                    gesteld, en bespreken we eventuele behandelopties die in gang worden gezet.
                                </>
                            }
                            question="Ik heb een slaaponderzoek gedaan. Wat is de volgende stap?"
                        />
                        <FaqItem
                            answer={faqItem2}
                            question="Uit het onderzoek is gebleken dat ik slaapapneu heb, wat nu?"
                        />
                        <FaqItem
                            answer="Helaas is de slaaprecorder niet herbruikbaar. De slaaprecorder kan je naar een batterijbak brengen."
                            question="Wat moet ik doen met de slaaprecorder zodra ik klaar ben met het slaaponderzoek?"
                        />
                        <FaqItem
                            answer={faqItem3}
                            question="Wat zijn de kosten van het slaaponderzoek?"
                        />
                        <FaqItem
                            answer={faqItem4}
                            question="Wat moet ik met de factuur doen om geld terug te krijgen?"
                        />
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}

export function OsasFaq() {
    const [searchParams] = useSearchParams();
    const somnologyOrganizationType = searchParams.get('somnologyOrganizationType');
    if (somnologyOrganizationType === SomnologyOrganizationType.ksyosMedicalCenter) {
        return ksyosMedicalCenterFaq();
    } else {
        return nsiFaq();
    }
}
